import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const SubmitPayrollPendingApproval = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div class="row mx-0 payroll-page">
              <div class="shadowclass mt-4">
                <h4 class="event-alert"> Submit Payroll Pending Approval </h4>
                <div class="col-md-4">
                  <div class="search-box mt-0">
                    <form type="GET">
                      <input type="text" placeholder="Search" name="keyword1" />
                      <input type="submit" />
                    </form>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="checklist-table remove-space ingredTable">
                    <thead>
                      <tr>
                        <th valign="bottom">
                          <span class="checkbox">
                            <input
                              type="checkbox"
                              id="PayrollIndividualSelectAll"
                            />
                            <label for="PayrollIndividualSelectAll"></label>
                          </span>
                        </th>
                        <th>
                          <a class="">Name</a>
                        </th>
                        <th> Reg. Wages</th>
                        <th> OT Wages</th>
                        <th> Total Wages</th>
                        <th>
                          Employee <br /> Var. Pay
                        </th>
                        <th>
                          Employee <br /> Meals
                        </th>
                        <th>
                          Employer <br /> Contribution
                        </th>
                        <th>
                          Employee <br /> Contribution
                        </th>
                        <th>
                          Witholding <br /> Tax
                        </th>
                        <th> Net Pay</th>
                        <th> Total Cost </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colspan="12">
                          <strong>No record found.</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="btn-sec-row clearfix my-3 my-sm-0">
                <input
                  class="btn cancel"
                  type="button"
                  id="cancel"
                  value="Reject"
                />
                <input
                  class="btn green-btn-revert mx-0 mx-sm-3"
                  type="submit"
                  id="submitBut"
                  value="Approve"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default SubmitPayrollPendingApproval;
